import type { StyleRule } from '@archipro-design/aria';
import { paragraphClassName } from '@archipro-design/aria';
import { productTileSlotClassNames } from '@archipro-design/aria';
import { archizeenTileClassName } from '@archipro-design/aria';
import { captionClassName, flexClassName } from '@archipro-design/aria';

import { paginationClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem, paginationSlotClassNames } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const GridWrapper: StyleRule<{ filterDrawerOpen?: boolean }> = ({
    theme,
}) => ({
    columnGap: pxToRem(6),
    rowGap: pxToRem(40),
    marginTop: pxToRem(20),
    '&.article': {
        marginTop: 0,
        columnGap: 0,
        rowGap: 0,
        '& > a:first-child': {
            borderTop: 'unset',
        },
    },
    '&.professional': {
        padding: 0,
    },
    [`&.product .${productTileSlotClassNames.variants}`]: {
        paddingTop: pxToRem(3),
        paddingBottom: pxToRem(3),
    },
    [theme.screen.laptop]: {
        columnGap: pxToRem(0),
        rowGap: pxToRem(130),
        marginTop: 0,
        '&.article': {
            rowGap: pxToRem(130),
        },
        '&.professional': {
            padding: 0,
        },
        [`&.product .${productTileSlotClassNames.variants}`]: {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
});

export const ArticleMobileStyle: StyleRule = ({ theme }) => ({
    borderBottom: `1px solid ${theme.siteVariables.colors.grey['150']}`,
    [`&:first-child`]: {
        borderTop: `1px solid ${theme.siteVariables.colors.grey['150']}`,
    },
    [`&.${archizeenTileClassName}.landscape`]: {
        paddingBottom: pxToRem(21),
        [`& .${svgIconClassName}`]: {
            paddingTop: pxToRem(1),
        },
    },

    [`& > .${flexClassName} > .${flexClassName}`]: {
        margin: pxArrayToRem([0, 4, 8, 0]),

        [`& .${captionClassName}`]: {
            minHeight: pxToRem(13),
        },

        [`& > .${flexClassName}`]: {
            margin: pxArrayToRem([2, 0, 0, 0]),
        },
    },

    [`&.${archizeenTileClassName}.all`]: {
        gridTemplateColumns: `[image] ${pxToRem(119)} [info] 1fr`,
        borderBottom: `1px solid ${theme.siteVariables.colors.grey[150]}`,
    },
});

export const TileGridWrapper: StyleRule = () => ({
    padding: 0,
});

export const PaginationWrapper: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(48),
    marginBottom: pxToRem(80),
    width: '100%',
    [theme.screen.laptop]: {
        width: 'unset',
        paddingTop: pxToRem(129),
        marginBottom: pxToRem(130),
        [`& .${paginationClassName}`]: {
            [`& .${paginationSlotClassNames.list}`]: {
                marginBottom: pxToRem(24),
            },
        },
    },

    [`& .${paginationSlotClassNames.divider}`]: {
        display: 'none',
    },

    [`& .${paginationSlotClassNames.paginationMetaData}`]: {
        [`&> *:not(:last-child)`]: {
            margin: 0,
        },
        padding: pxArrayToRem([0, 10, 0, 10]),
        [theme.screen.laptop]: {
            padding: 'unset',
        },
    },
});

export const NoResultWrapper: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([32, 18, 130, 18]),

    [theme.screen.laptop]: {
        padding: pxArrayToRem([50, 50, 130, 50]),
    },

    [`& .${paragraphClassName}`]: {
        margin: 0,
        fontSize: pxToRem(16),
        lineHeight: pxToRem(24),

        [theme.screen.laptop]: {
            margin: 0,
            fontSize: theme.siteVariables.fontSizes[`paragraph01`],
            lineHeight: theme.siteVariables.lineHeightSmall,
        },
    },
});
